import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import ReviewArea from './qualityreview/ReviewArea'
import Guidelines from './qualityreview/Guidelines'
import Display from '../../typography/Display'

import {
  isOeReviewer,
  isQuestCopyEditorOrQuestAuthorOrQuestManager,
  isExternalReviewer
} from '../../../utils/user'
import {
  userCanViewInternalReviewInfo,
  getReviewStatus,
  questIsInQualityReview,
  questIsInRejectedState
} from '../../../utils/review'
import { oeReview } from '../../../utils/messages'
import { messages as labels } from '../../../utils/messages/label'

class QualityReview extends Component {
  render() {
    const { intl } = this.props

    const intlReviewTypes = {
      standards: intl.formatMessage(labels.standards),
      final: intl.formatMessage(labels.final)
    }

    return (
      <div className="quality-review-container">
        <Display>{oeReview}</Display>
        <div className="line" />
        <Guidelines />
        {this.canViewQualityReviewAreas() && (
          <div className="quality-reviews">
            <ReviewArea
              reviewType={'standards'}
              intlReviewType={intlReviewTypes.standards}
            />
            <div className="line review-divider" />
            <ReviewArea
              reviewType={'final'}
              intlReviewType={intlReviewTypes.final}
            />
          </div>
        )}
      </div>
    )
  }

  canViewQualityReviewAreas() {
    const { user, quest, previousReviews, currentReviews, organization } =
      this.props
    const reviewStatus = getReviewStatus(quest)
    if (isExternalReviewer(user)) {
      return false
    } else {
      return (
        (userCanViewInternalReviewInfo(user, quest) &&
          (currentReviews.length > 0 || previousReviews.length > 0)) ||
        (isOeReviewer(user) &&
          (questIsInQualityReview(quest) ||
            reviewStatus === 'rejected' ||
            previousReviews.length > 0)) ||
        (isQuestCopyEditorOrQuestAuthorOrQuestManager(
          user,
          quest,
          organization
        ) &&
          (questIsInRejectedState(quest) || currentReviews.length > 0))
      )
    }
  }
}

QualityReview.propTypes = {
  quest: PropTypes.object,
  user: PropTypes.object,
  currentReviews: PropTypes.array,
  dispatch: PropTypes.func,
  previousReviews: PropTypes.array,
  organization: PropTypes.object,
  intl: PropTypes.object.isRequired
}

export default injectIntl(QualityReview)



// WEBPACK FOOTER //
// ./src/components/quest/review/QualityReview.js